<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div style="padding-bottom: 50px;">
<!--        <van-tabs v-model="active">-->
<!--            <van-tab title="全部"></van-tab>-->
<!--            <van-tab title="待支付"></van-tab>-->
<!--            <van-tab title="已支付"></van-tab>-->
<!--            <van-tab title="已完成"></van-tab>-->
<!--        </van-tabs>-->

        <van-empty
            style="background: #F6F6FC;"
            v-if="list.length === 0 && !loading"
            description="暂无数据"
        />

        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            loading-text='正在加载...'
            @load="onLoad"
        >
            <van-card style="background: white;" @click="$router.push('/my_order_detail?id='+order.id)" :num="order.num"
                      v-for="order in list"
            >
                <template #tags>
                    <van-tag style="margin-top: 4px;" size="large" :color="order.stateColor" v-if="!order.gift">{{ order.stateName }}</van-tag>
                    <span v-if="order.gift">
                        <van-icon name="gift-o" size="24" color="#F55447" style="vertical-align: middle;"/><span style="margin-left: 5px;color:var(--color);font-size: 16px;vertical-align: middle;">{{order.gift.fromUserName+' 赠送'}}</span>
                    </span>
                </template>
                <template #title>
                    <div style="font-size: 16px;">{{order.product.name}}</div>
                </template>
                <template #price>
                    <div style="color: var(--color); font-size: 16px;margin-top: 4px;">￥{{(order.priceInCent / 100).toFixed(2)}}</div>
                </template>
                <template #thumb>
                    <van-image :src="baseCdnUrl+'/api/public/product_'+order.productId+'.jpg'"/>
                </template>
                <template #desc>
                    <div style="margin-top: 4px;">{{order.summary}}</div>
                </template>
                <template #footer>
                    <van-button v-if="order.state === 'SUCCESS' && order.numUsed < order.num" icon="clock" color="var(--color)" size="mini" style="width: 58px" @click.stop="appointmentClicked(order)">预约</van-button>
                    <van-button color="var(--color)" size="mini" icon="cart" style="width: 68px" @click.stop="reOrderClicked(order)">再次购买</van-button>
                </template>
            </van-card>

        </van-list>
    </div>
</template>

<script>
import moment from "moment";
import http, {BASE_CDN_URL, BASE_URL} from "@/utils/http";
import qs from "qs";

export default {
    name: "MyProductOrder",
    data() {
        return {
            baseUrl: BASE_URL,
            baseCdnUrl: BASE_CDN_URL,
            spinShow: false,
            loading: false,
            finished: false,
            keywords: '',
            item:{},
            list: [],
            sort: 'state desc',

            active: 0,
        };
    },
    created() {
        this.loadList();
    },
    methods: {
        reload: function() {
            this.list = [];
            this.loadList();
        },
        onLoad() {
            this.loadList();
        },
        loadList: function() {
            var payload = {start: this.list.length, limit: 10, keywords : this.keywords, productCat: this.cat};
            if(this.sort) {
                var parts = this.sort.split(' ');
                payload.sortColumn = parts[0];
                payload.sortDirection = parts[1];
            }
            var filter = {};
            if(this.suitableSex) {
                filter['suitable_sex'] = this.suitableSex;
            }
            if(this.suitablePeople) {
                filter['suitable_people'] = this.suitablePeople;
            }
            payload.filter = JSON.stringify(filter);
            // console.log(payload)
            this.loading = true;
            http.post('/api/personal/list_orders', qs.stringify(payload))
                .then(response => {
                    // console.log(response.data)
                    this.loading = false;
                    if (!response.data.result) {
                        this.finished = true;
                    } else {
                        if(response.data.extra.items.length === 0){
                            this.finished = true;
                        }else{
                            var items = response.data.extra.items;
                            items.forEach(item => {
                                var stateColor = '#FF976A';
                                switch (item.state) {
                                    case 'CLOSED':
                                        stateColor = '#3C3F41';
                                        break;
                                    case 'SUCCESS':
                                        stateColor = '#0CC160';
                                        break;
                                }
                                item.stateColor = stateColor;
                            })
                            // console.log(items)
                            this.list.push(...items);
                        }
                    }
                })
                .catch(error => {
                    // console.error(error)
                    this.loading = false;
                    this.finished = true;
                });
        },
        reOrderClicked(order) {
            window.location.replace(this.baseUrl + '/api/public/wx_oid?url=' + encodeURIComponent(this.baseUrl + '/product_order?id='+order.product.id));
        },
        appointmentClicked(order) {
            this.$router.push('/my_appointment_edit?poi='+order.id)
        }

    }
}
</script>

<style scoped>

</style>